import { QBuildTableRFC } from "./QBuildTableRFC";
import { Globals } from "./Globals";

export class QManageTablesRFC extends QBuildTableRFC {
  constructor() {
    super();
  }

  DoTransactionComplete(response, callBackObj) {
    var wsMgr = Globals._wsMgr;
    var tableManager = callBackObj?.fTableMgr ?? wsMgr.fTableManager;

    var r = JSON.parse(response);
    var success = r["success"];
    callBackObj?.resolve?.(r);

    if (Globals._wsMgr.fWaiting) {
      Globals._wsMgr.ClearAppLoadingAnimation();
      Globals._wsMgr.fWaiting = null;
    }

    if (!success) {
      callBackObj?.reject?.(r);
      return;
    }

    if (r["tables"]) {
      Globals._wsMgr.fOrgInfo.SetAppendTableList(r["tables"]);
      if (tableManager) {
        for (var tableIdx in r["tables"]) {
          var aTable = r["tables"][tableIdx];
          if (aTable["ID"] === tableManager.fTableInfo["ID"]) {
            tableManager.fTableInfo = aTable;
          }
        }
      }
    }

    if (r["appendOverrides"] != null && tableManager)
      tableManager.LoadOverrides(r["appendOverrides"]);

    Globals._wsMgr.BroadcastTopic("SyncTableManager", tableManager);
  }
}
